interface QueryParams {
  [key: string]: string;
}

export const publicPath =
  process.env.REACT_APP_PUBLIC_URL === "/"
    ? ""
    : process.env.REACT_APP_PUBLIC_URL;

// console.log("publicPath", publicPath);

// Convert query string from URL to object
export const queryStrToObject = (): QueryParams => {
  const url = window.location.href;
  const queryParams: QueryParams = {};

  if (url.includes("?")) {
    const queryString = url.split("?")[1];
    const params = new URLSearchParams(queryString);

    for (const [key, value] of params) {
      queryParams[key] = value;
    }

    // Perform specific operations only if certain keys are present
    // if (queryParams.lang) {
    //   VueI18n.locale = queryParams.lang;
    //   store.commit("setHeaders", { Language: queryParams.lang });
    // }
    // if (queryParams.token) {
    //   store.commit("setHeaders", { Authorization: queryParams.token });
    // }
  }

  // Use object destructuring with the rest operator to avoid modifying specific keys and enhance code immutability
  // const { token, lang, ...cleanParams } = queryParams;

  return queryParams;
};

// 处理从APP端传过来的JSON字符串参数
export const handleFromAppParams = (str: string) => {
  if (!str) return null;
  let resObj = JSON.parse(str);
  // if (resObj.token || resObj.lang) {
  //   // store.commit('setHeaders', {
  //   // 	Authorization: resObj.token,
  //   // 	Language: resObj.lang
  //   // })
  // }
  // if (resObj.lang) VueI18n.locale = resObj.lang
  // if (resObj.token) delete resObj.token
  // if (resObj.lang) delete resObj.lang

  console.log("urlParams", resObj);

  return resObj;
};

export const isEmail = (email: any): boolean => {
  const expr = /^[\.A-Za-z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)$/;
  return expr.test(email);
};

/**
 * 判断手机类型
 * return [ isAndroid, isIOS, isIOS9 ]
 */
export const detectMobileOS = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isAndroid =
    userAgent.includes("android") || userAgent.includes("linux");
  const isIOS = userAgent.includes("like mac os x");
  let isIOS9 = false;

  if (isIOS) {
    const versionMatch = userAgent.match(/os (\d+)_(\d+)_?(\d+)?/);
    if (versionMatch) {
      const [, majorVersion] = versionMatch;
      isIOS9 = parseInt(majorVersion, 10) >= 9;
    }
  }

  return {
    isAndroid,
    isIOS,
    isIOS9,
  };
};

/**
 * 判断dia与sys当前属于哪个区间颜色
 * @param {Number dia} dia
 * @param {Number sys} sys
 */
export const determineBPColor = (dia: number, sys: number): string => {
  let color;
  switch (true) {
    case dia <= 80 && sys <= 120:
      color = "#86D46A";
      break;
    case dia <= 85 && sys <= 130:
      color = "#6ECD4C";
      break;
    case dia <= 90 && sys <= 140:
      color = "#60C03E";
      break;
    case dia <= 100 && sys <= 160:
      color = "#F8CE3C";
      break;
    case dia <= 110 && sys <= 180:
      color = "#FF8E4F";
      break;
    default:
      color = "#EB6451";
      break;
  }
  return color;
};

// 防抖函数
export const debounce = (
  func: (...args: any[]) => void,
  wait: number
): ((...args: any[]) => void) => {
  let timeout: ReturnType<typeof setTimeout> | null = null;
  return function (...args: any[]) {
    const later = () => {
      timeout = null;
      func(...args);
    };
    if (timeout !== null) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(later, wait);
  };
};

export const sleep = (time: number) =>
  new Promise((resolve) => setTimeout(resolve, time));

/* 判断是否为微信浏览器
 * 兼容ios
 * */
// export const isWeiXinBrower = () => {
// 	return /micromessenger/i.test(navigator.userAgent.toLowerCase()) || typeof navigator.wxuserAgent !== 'undefined'
// }

/**
 * 判断是否安装app
 * @url ios,android 提供（打开app的链接）
 * @callback （未安装app的回调）
 * */
export const openApp = (url: string, callback: Function) => {
  let hasApp = true,
    t0 = 1000,
    t1 = Date.now();
  setTimeout(function () {
    //启动app时间较长处理
    let t2 = Date.now();
    if (t2 - t1 < t0 + 100) {
      hasApp = false;
    }
  }, t0);

  window.location.href = url;
  setTimeout(function () {
    if (!hasApp) {
      if (callback) {
        callback(hasApp);
      }
      callback && callback(hasApp);
    }
  }, 2500);
  setTimeout(function () {
    location.reload();
  }, 2400);
};


export const preprocessLaTeX = (content: string) => {
  // Replace block-level LaTeX delimiters \[ \] with $$ $$

  // const blockProcessedContent = content.replace(
  //   /\\\[(.*?)\\\]/g, // 将 (.*?) 改为 ([\s\S]*?) 以匹配多行内容
  //   (_, equation) => `$$${equation}$$`
  // );

  // 匹配块级 LaTeX 公式 \[ 和 \]，支持公式前后的空白字符（包括换行）
  const blockProcessedContent = content.replace(
    /\\\[\s*([\s\S]*?)\s*\\\]/g, // 匹配 \[ 和 \] 之间的内容，支持多行和空格
    (_, equation) => `$$${equation}$$`
  );

  // Replace inline LaTeX delimiters \( \) with $ $
  const inlineProcessedContent = blockProcessedContent.replace(
    /\\\((.*?)\\\)/g,
    (_, equation) => `$$${equation}$$`
  );

  return inlineProcessedContent;
};

